
import get from 'lodash/get';

import {
    CATEGORY_OPERATION_ACTION_TYPE,
    CATEGORY_SET_ACTUAL_CATEGORY_ACTION_TYPE
} from '../sagas/category';

import {
    GET_PROJECT_ACTION_TYPE,
    REFRESH_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    actualCategoryFullName: null,
};

function getCategoryFullName(listName, categoryName) {
    return `${listName}:${categoryName}`
}

function getActualCategoryFullName(state, data) {
    return state.actualCategoryFullName
        ? state.actualCategoryFullName
        : getFirstCategoryFullName(data);
}

function getFirstCategoryFullName(data) {
    return (data.parcel.length > 0)
        ? getCategoryFullName(data.parcel[0].list_name, data.parcel[0].category_name)
        : null;
}

function processCategoryItems(state, data) {
    let categoryItems = {};
    data.items.forEach(item => {
        let category = categoryItems[item.category_name] || [];
        category.push(item);
        categoryItems[item.category_name] = category;
    });
    return categoryItems;
}

function processCategoryItemParcel(state, data) {
    let categoryItemParcel = {};
    data.parcel.forEach(item => {
        let id = getCategoryFullName(item.list_name, item.category_name);
        let category = categoryItemParcel[id] || [];
        category.push(item);
        categoryItemParcel[id] = category;
    });
    return categoryItemParcel;
}

export function getActualCategoryName(state) {
    const actualCategoryFullName = get(state.category, 'actualCategoryFullName') || ':';
    return actualCategoryFullName.split(':')[1];
}

export function getCategoryData(state) {
    return state.data;
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(CATEGORY_OPERATION_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case CATEGORY_OPERATION_ACTION_TYPE.SUCCESS:
                return {
                    ...loaderReducer(state, action),
                    actualCategoryFullName: getActualCategoryFullName(state, action.data.result.category),
                    categoryItems: processCategoryItems(state, action.data.result.category),
                    categoryItemParcel: processCategoryItemParcel(state, action.data.result.category)
                };

            case CATEGORY_SET_ACTUAL_CATEGORY_ACTION_TYPE:
                return {
                    ...state,
                    actualCategoryFullName: action.category
                };

            case REFRESH_PROJECT_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
